import Flickity from "flickity";

const SELECTORS = {
  componentGeneral: ".slider-one-element .view-content",
  componentView: ".club--view--blog-related .view-content",
  componentBlockHeroSlider: ".club__hero--slider .field__items",
  componentBlogFilterRadios:
    ".club--view--blog .club__view--categories--blog .view-content",
  componentBlogProductIntro: ".product-intro .product-intro__list",
  componentBlogHeroVideo: ".hero-video__intro .hero-video__list",

};

window.Drupal.behaviors.gallery = {
  attach: (context) => {
    const ins = {};
    for (const instance in SELECTORS) {
      ins[instance] = [...context.querySelectorAll(SELECTORS[instance])];
      if (ins[instance].length) {
        for (const component of ins[instance]) {
          if (component.children.length > 1) {
            const flickity = new Flickity(component, {
              cellAlign: "left",
              wrapAround: false,
              lazyLoad: false,
              contain: true,
              pageDots: true,
              adaptiveHeight: true,
              imagesLoaded: true,
            });
          }
        }
      }
    }
  },
};
